module.exports = __webpack_public_path__ + "static/media/image-1.10a5db8e.jpg";